import { ComponentClass } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
export { ComponentClass };

// Chunk name is same the the chunk which contains compose actions for mini mail (mini-mail-compose-actions-mail)
const lazyModuleComposeMail = new LazyModule(
    () => import(/* webpackChunkName: "MailCompose" */ './lazyIndex')
);
export let MailCompose = createLazyComponent(lazyModuleComposeMail, m => m.MailCompose);

// Chunk name is same the the chunk which contains compose actions for mini calendar (mini-mail-compose-actions-calendar)
const lazyModuleComposeCalendar = new LazyModule(
    () => import(/* webpackChunkName: "MailComposeCalendar" */ './lazyIndex')
);
export let MailComposeCalendar = createLazyComponent(lazyModuleComposeCalendar, m => m.MailCompose);

// Chunk name is same the the chunk which contains newMessage compose action (mini-mail-compose-actions-common)
const lazyModuleComposeCommon = new LazyModule(
    () => import(/* webpackChunkName: "MailComposeCommon" */ './lazyIndex')
);
export let MailComposeCommon = createLazyComponent(lazyModuleComposeCommon, m => m.MailCompose);
